import type { AccountId } from '../../../../generated-types';

export default (
    accountId: AccountId,
    newPaymentDay: number | undefined,
    currentDay: number,
    isPaymentDateInCurrentMonth: boolean,
) => {
    const targetPaymentDay = newPaymentDay ?? currentDay;
    return {
        accountId,
        paymentDay: targetPaymentDay,
        paymentDayNextMonth: isPaymentDateInCurrentMonth && targetPaymentDay <= new Date().getDate(),
    };
};
